import { VolumeBar } from './VolumeBar';
export default VolumeBar;
